export const uppercaseRegex = /[A-Z]+/;
export const lowercaseRegex = /[a-z]+/;
export const specialCharacterRegex = /[!+@#$%^&*()\-_"=+{}; :,<.>]+/;
export const digitRegex = /\d+/;
export const noSpaceRegex = /^\S*$/;
export const emailRegex =
  /^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
